import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

const NewsView = ({
    blogData,
    open,
    handleClose 
}) => {
  return (
    <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
    >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {blogData?.title || 'N/A' }
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {
            blogData.cover ? 
              <img 
                  src={`${blogData.cover}`}
                  alt={blogData.title}
                  loading="lazy"
                  className='max-h-400 h-[100%] max-w-500 w-[100%] rounded-lg aspect-[3/2] object-contain'
              />
            :''
          }
        <Typography gutterBottom mt={2} >
            <div dangerouslySetInnerHTML={{__html: blogData?.description || 'N/A'}} />
          </Typography>

        <div className='flex justify-between mt-8' >
            <div className='text-[10px] text-black font-bold' >
               <span className='text-slate-500' >Published At - </span> {moment(blogData?.published_at)?.format('DD MMMM, YYYY')}
            </div>
            <div className='text-[10px] text-black font-bold'  >
                <span className='text-slate-500' >Author -</span> {blogData?.author}
            </div>
        </div>

        </DialogContent>
    </Dialog>
  )
}

export default NewsView